import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import {
  getEventAddonItemsByType,
  getRawEventAddonItemsPrice,
  PRO_FREEMIUM_EVENT_FEATURES,
} from '../../../../apps/pro/components/FreemiumEventPurchase/helpers';
import CheckmarkIcon from '../../../../components/icons/CheckmarkIcon';
import Button from '../../../../components/global/Button';
import BoxedItem from '../../../../components/global/BoxedItem';
import ArrowRight from '../../../../components/icons/ArrowRight';
import useEventAddonPurchase from '../../../../apps/pro/components/FreemiumEventPurchase/hooks/useEventAddonPurchase';
import { EVENT_ADDON_ITEM_TYPE } from '../../../../constants/event-items';
import {
  formatNumber,
  formatPriceForDisplay,
} from '../../../../util/format-money';
import Spinner from '../../../../components/global/Spinner';
import getConfig from '../../../../util/config';

const propTypes = {
  handleChange: PropTypes.func,
  handleSubmit: PropTypes.func,
};

const EventSKUSelection = ({ handleChange, handleSubmit }) => {
  const { marcomUrl } = getConfig();
  const {
    eventAddonItems = [],
    loadingEventAddonItems,
  } = useEventAddonPurchase({
    eventAddonItemsQueryVars: { enable_photo_finder_event_addon_items: true },
    defaultEventAddonItemTypes: [
      EVENT_ADDON_ITEM_TYPE.WALDOFIED_PHOTO_FINDER,
      EVENT_ADDON_ITEM_TYPE.WALDOFIED_PHOTO_FINDER_PLUS,
    ],
  });

  const [waldofiedPhotoFinderEventAddonItem] = getEventAddonItemsByType(
    eventAddonItems,
    EVENT_ADDON_ITEM_TYPE.WALDOFIED_PHOTO_FINDER,
  );
  const [waldofiedPhotoFinderPlusEventAddonItem] = getEventAddonItemsByType(
    eventAddonItems,
    EVENT_ADDON_ITEM_TYPE.WALDOFIED_PHOTO_FINDER_PLUS,
  );

  if (loadingEventAddonItems) {
    return (
      <div className="p-5 d-flex align-items-center justify-content-center">
        <Spinner />
      </div>
    );
  }

  return (
    <Fragment>
      <div className="pro-register-view-event-selection">
        <BoxedItem className="d-flex align-items-center flex-column">
          <h2>
            Up to{' '}
            {formatNumber(
              waldofiedPhotoFinderEventAddonItem?.features
                ?.photo_finder_credits,
            )}{' '}
            Photos
          </h2>
          <Button
            onClick={() => {
              handleChange({
                target: {
                  name: 'event_addon_item_id',
                  value: waldofiedPhotoFinderEventAddonItem.id,
                },
              });

              handleSubmit();
            }}
            btnBlock
          >
            $
            {formatPriceForDisplay(
              getRawEventAddonItemsPrice({
                eventAddonItems: [waldofiedPhotoFinderEventAddonItem],
              }),
            )}
          </Button>
        </BoxedItem>
        <BoxedItem className="d-flex align-items-center flex-column">
          <h2>
            Up to{' '}
            {formatNumber(
              waldofiedPhotoFinderPlusEventAddonItem?.features
                ?.photo_finder_credits,
            )}{' '}
            Photos
          </h2>
          <Button
            onClick={() => {
              handleChange({
                target: {
                  name: 'event_addon_item_id',
                  value: waldofiedPhotoFinderPlusEventAddonItem.id,
                },
              });

              handleSubmit();
            }}
            btnBlock
          >
            $
            {formatPriceForDisplay(
              getRawEventAddonItemsPrice({
                eventAddonItems: [waldofiedPhotoFinderPlusEventAddonItem],
              }),
            )}
          </Button>
        </BoxedItem>
      </div>
      <p className="text-center">
        Hosting a larger event?{' '}
        <a
          href="mailto:sales@waldophotos.com"
          className="d-inline-flex align-items-center"
        >
          Contact sales{' '}
          <ArrowRight className="ml-1" size={15} color="#0e84fe" />
        </a>
      </p>
      <hr />
      <div className="pro-register-view-event-features">
        <ul>
          {PRO_FREEMIUM_EVENT_FEATURES.map((feature, index) => (
            <li key={index} className="text-dark text-sm text-bold">
              {typeof feature === 'string' ? (
                <>
                  <CheckmarkIcon
                    color="#f1794e"
                    size="14px"
                    className="feature-icon"
                  />
                  <span>{feature}</span>
                </>
              ) : (
                <span>{feature}</span>
              )}
            </li>
          ))}
        </ul>
      </div>
      <div className="pro-register-view-annual-subscriptions">
        <span className="text-dark text-extra-bold">
          Have more than 15 events a year?
        </span>
        <Button
          btnStyle="primary"
          btnOutline
          href={`${marcomUrl}/pricing/business`}
          target="_blank"
          rel="noopener noreferrer"
          className="text-bold"
        >
          Check out annual subscriptions
        </Button>
      </div>
    </Fragment>
  );
};
EventSKUSelection.propTypes = propTypes;

export default EventSKUSelection;
